module.exports = __webpack_public_path__ + "img/BG_header_producteur.522e61e7.jpg";